import ImageViewBox from './src/main.js'

export default ImageViewBox



// WEBPACK FOOTER //
// ./src/views/question-editor/components/image-view-box/index.js